import React, { useCallback } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useDispatch } from 'react-redux';
import * as Styles from './BreadcrumbsWidget.scss';
import { dispatchSkyfireMethods, preventDefault } from '../../utils';
export default function BreadcrumbsWidget(props) {
    const dispatch = useDispatch();
    useStyles(Styles);
    const handleSelected = useCallback((onItemSelected) => {
        if (props.currTemplate) {
            dispatchSkyfireMethods(dispatch, props.currTemplate, onItemSelected);
        }
    }, [dispatch, props.currTemplate]);
    return props.data.items && props.data.items.length > 0 ? (React.createElement("div", { className: Styles.breadCrumbs },
        React.createElement("music-breadcrumbs", { items: processBreadcrumbsItems(props.data.items), onClick: preventDefault }))) : null;
    function processBreadcrumbsItems(items) {
        return (items || []).map((item) => {
            var _a, _b;
            return ({
                label: item === null || item === void 0 ? void 0 : item.text,
                href: (_a = item === null || item === void 0 ? void 0 : item.link) === null || _a === void 0 ? void 0 : _a.deeplink,
                breadcrumbEventActivate: handleSelected.bind(this, (_b = item === null || item === void 0 ? void 0 : item.link) === null || _b === void 0 ? void 0 : _b.onItemSelected),
            });
        });
    }
}
